import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { SheetsMetadata } from "@dis/models";

import { SSID } from "@dis/models";
import { doc, updateDoc } from "firebase/firestore";
import { docData, FIRESTORE } from "@dis/firebase";

const COLLECTION = "sheets-metadata";

@Injectable({
  providedIn: "root",
})
export class SheetsMetadataService {
  private firestore = inject(FIRESTORE);

  watchSheetMetadata(SpreadsheetId: SSID): Observable<SheetsMetadata> {
    return docData(doc(this.firestore, COLLECTION, SpreadsheetId)) as Observable<SheetsMetadata>;
  }

  updateSheetMetadata(
    SpreadsheetId: SSID,
    metadata: Partial<SheetsMetadata>,
    mutationKey?: string,
    action_type: string = "SHEETS_STORE"
  ): Promise<void> {
    return updateDoc(doc(this.firestore, COLLECTION, SpreadsheetId), {
      ...metadata,
      action_type,
      updatedAt: new Date().getTime(),
      mutationKey: mutationKey || null,
    });
  }
}
